module.exports = __webpack_public_path__ + "img/girl-evaluation-test.276f1394.png";